import { TUnknownErrorFactory } from '../types';

export const createUnknownError: TUnknownErrorFactory = () => new DOMException('', 'UnknownError');
